import {CART, shopUtilities, WISHLIST} from "@global/shop-utilities/shop-utilities";

export const productTableList = (elements) => {
    elements.forEach((element) => {
        const hiddenElements = element.querySelectorAll('.pim-product-table-list__content[hidden], .pim-product-table-list__hr[hidden]')

        if (hiddenElements.length > 0) {
            const button = document.createElement("button")
            button.classList.add("button", "button--secondary", "icon--before", "icon--arrow-down")
            button.addEventListener("click", () => {
                hiddenElements.forEach(hiddenElement => hiddenElement.hidden = false)
                element.removeChild(button)
            })

            button.innerText = window.jsI18N.pimProductTableList?.showAll || "LL Alle anzeigen"

            element.appendChild(button)
        }
    })

    // Register Shop-Callbacks
    const wishlistItems = document.querySelectorAll(`.pim-product-table-list .${shopUtilities.options.wishlist.class}`);
    wishlistItems.forEach(item => {
        shopUtilities.registerListeners(item, WISHLIST);
    });

    const cartItems = document.querySelectorAll(`.pim-product-table-list .${shopUtilities.options.cart.class}`);
    cartItems.forEach(item => {
        shopUtilities.registerListeners(item, CART);
    })
}
